import { buildParams, http } from "./http"

export const getActualBudget = () => 
  http.get<any, any>(`/loyalty/budget`)

export const getBudgets = () => 
  http.get<any, any>(`/loyalty/budgets`)

export const updateStatus = (id: number, dto: any) => 
  http.put<any, any>(`/loyalty/status/${id}`, dto)

export const freezeStatus = () =>
  http.post<any, any>(`/loyalty/statuses/my/freeze`)

export const getStatusesStats = (source: string = "topgun") => 
  http.get<any, any>(`/loyalty/statuses/stats${buildParams({source})}`)

export const getWishesAll = () => 
  http.get<any, any>(`/loyalty/wishes_all`)

export const createBotMassMessage = (dto: any) => 
  http.post<any, any>(`/loyalty/telegram/mass_message`, dto)

export const createBotMassMessageTest = (dto: any) => 
  http.post<any, any>(`/loyalty/telegram/mass_message_test`, dto)

export const createOrderReview = (dto: any) => 
  http.post<any, any>(`/loyalty/review`, dto)

export const updateOrderReview = (id: number, dto: any) => 
  http.put<any, any>(`/loyalty/review/${id}`, dto)

export const deleteOrderReview = (id: number) => 
  http.delete<any, any>(`/loyalty/review/${id}`)

export const getSubsList = (query: any) =>
  http.get<any, any>(`/loyalty/admin/subs${buildParams(query)}`)

export const getBonusesList = (query: any) =>
  http.get<any, any>(`/loyalty/admin/bonuses${buildParams(query)}`)

export const getNotifiesList = (query: any) =>
  http.get<any, any>(`/loyalty/admin/notifies${buildParams(query)}`)

export const getClients = (params: any) =>
  http.get<any, any>(`/loyalty/clients${buildParams(params)}`)

export const getClientById = (id: number) =>
  http.get<any, any>(`/loyalty/clients/${id}`)

export const getRefsById = (id: number) =>
  http.get<any, any>(`/loyalty/clients_refs/${id}`)

export const adjustBalance = (id: number, dto: any) =>
  http.post<any, any>(`/loyalty/account/${id}/adjust`, dto)

export const checkAccount = (dto: any) =>
  http.post<any, any>(`/loyalty/auth/check_sign`, dto)

export const signInWithCode = (dto: any) =>
  http.post<any, any>(`/loyalty/auth/code`, dto)

export const signUpWithMaxma = (dto: any) =>
  http.post<any, any>(`/loyalty/auth/signup`, dto)

export const getAccount = () =>
  http.get<any, any>(`/loyalty/account_x`)

export const getProjectReview = () =>
  http.get<any, any>(`/loyalty/project_review`)

export const projectReview = (dto: any) =>
  http.post<any, any>(`/loyalty/project_review`, dto)

export const updateAdmAccount = (id: number, dto: any) =>
  http.put<any, any>(`/loyalty/account/${id}`, dto)

export const updateAccount = (dto: any) =>
  http.put<any, any>(`/loyalty/account`, dto)

export const deleteAccount = (id: number) =>
  http.delete<any, any>(`/loyalty/account/${id}`)



